import { Module } from 'vuex';

import actions from './actions';
import mutations from './mutations';
import state from './state';

import Checkout from '@/app/features/Checkout/module';
import Customer from '@/app/features/Customer/module';
import Behavior from '@/app/features/Behavior/module';
import Error from '@/app/features/Error/module';
import InteractEventTracker from '@/app/features/InteractEventTracker/module';

import { IApp } from '@/interfaces/App';

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  modules:{
    Checkout,
    Customer,
    Behavior,
    Error,
    InteractEventTracker,
  }
} as Module<IApp, any>;
